export const getUser = () => {
    const user = window.localStorage.getItem('userAdmin');

    if (user) {
        return JSON.parse(user);
    } else {
        return undefined;
    }
};
